import type { LocalizedFieldDto } from '@carvia/ros-client-types';

/** Localized content may include Spanish on some entities (e.g. custom contract checkboxes). */
type LocalizedField = LocalizedFieldDto & { es?: string };

export const getLocalizedField = (
  field: LocalizedField | null | undefined,
  language: string | undefined,
): string => {
  if (!field) return '';
  if (language === 'de') return field.de;
  if (language === 'es') {
    const es = field.es;
    return es && es.trim() !== '' ? es : field.en;
  }
  return field.en;
};
